import type { App } from 'vue';
import type { Router } from 'vue-router';
import type { useMenu } from '../menu';
import type { PossiblyAsyncIntegration } from './types/asyncIntegration';
import type { Integration } from './types/integration';
import type { IntegrationsStore } from './types/integrationsStore';

export interface IntegrationServices<
  Store extends IntegrationsStore<Record<string, PossiblyAsyncIntegration>>,
> {
  app?: App;
  store?: Store;
  router?: Router;
  menu?: ReturnType<typeof useMenu>;
  resolver?: <I extends Integration>(integration: I) => Promise<I>;
}

export const services: IntegrationServices<IntegrationsStore<{}>> = {
  app: undefined,
  store: undefined,
  router: undefined,
  menu: undefined,
  resolver: undefined,
};
